/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfAppleOAuthResponseCode } from '../models';
// @ts-ignore
import type { BfOtcAttempt } from '../models';
// @ts-ignore
import type { BfToken } from '../models';
// @ts-ignore
import type { BfTokenClaims } from '../models';
// @ts-ignore
import type { BfTokenIntrospection } from '../models';
/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Apple OAuth2
         * @param {string} code 
         * @param {string} [state] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuthForm: async (code: string, state?: string, user?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('appleAuthForm', 'code', code)
            const localVarPath = `/v1/auth/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }

            if (state !== undefined) { 
                localVarFormParams.set('state', state as any);
            }

            if (user !== undefined) { 
                localVarFormParams.set('user', user as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Callback for Apple OAuth2, from SIWA
         * @summary Apple iOS SIWA Auth
         * @param {BfAppleOAuthResponseCode} bfAppleOAuthResponseCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAppleFromApp: async (bfAppleOAuthResponseCode: BfAppleOAuthResponseCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfAppleOAuthResponseCode' is not null or undefined
            assertParamExists('authAppleFromApp', 'bfAppleOAuthResponseCode', bfAppleOAuthResponseCode)
            const localVarPath = `/v1/auth/apple/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfAppleOAuthResponseCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Facebook OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Google OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        google: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reports whether a session token or access key is usable now, and the groups its user currently holds (RFC 7662). `active` is false for an expired, revoked, malformed or unknown token. `groupsValidUntil` is how long the reported groups may be cached. The token goes in the form body, never the query string.
         * @summary Introspect token
         * @param {string} token The token as the resource server received it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspect: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('introspect', 'token', token)
            const localVarPath = `/v1/auth/introspect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (token !== undefined) { 
                localVarFormParams.set('token', token as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Microsoft OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoft: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/microsoft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm the token is valid and return the claims. A 409 carries replacement tokens: after group changes, before expiry, or to upgrade a JWT when `format=compact` is requested.
         * @summary Validate token
         * @param {ValidateFormatEnum} [format] Ask for compact tokens; a session still on a JWT is upgraded with a 409
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (format?: ValidateFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirms a OTC, and performs an action based on the token type.
         * @summary Validate OTC
         * @param {BfOtcAttempt} bfOtcAttempt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOtc: async (bfOtcAttempt: BfOtcAttempt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfOtcAttempt' is not null or undefined
            assertParamExists('validateOtc', 'bfOtcAttempt', bfOtcAttempt)
            const localVarPath = `/v1/auth/otc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfOtcAttempt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Apple OAuth2
         * @param {string} code 
         * @param {string} [state] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleAuthForm(code: string, state?: string, user?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleAuthForm(code, state, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.appleAuthForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Callback for Apple OAuth2, from SIWA
         * @summary Apple iOS SIWA Auth
         * @param {BfAppleOAuthResponseCode} bfAppleOAuthResponseCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authAppleFromApp(bfAppleOAuthResponseCode: BfAppleOAuthResponseCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authAppleFromApp(bfAppleOAuthResponseCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authAppleFromApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Facebook OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facebook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.facebook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Google OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async google(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.google(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.google']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reports whether a session token or access key is usable now, and the groups its user currently holds (RFC 7662). `active` is false for an expired, revoked, malformed or unknown token. `groupsValidUntil` is how long the reported groups may be cached. The token goes in the form body, never the query string.
         * @summary Introspect token
         * @param {string} token The token as the resource server received it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introspect(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfTokenIntrospection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introspect(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.introspect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Microsoft OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async microsoft(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.microsoft(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.microsoft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm the token is valid and return the claims. A 409 carries replacement tokens: after group changes, before expiry, or to upgrade a JWT when `format=compact` is requested.
         * @summary Validate token
         * @param {ValidateFormatEnum} [format] Ask for compact tokens; a session still on a JWT is upgraded with a 409
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(format?: ValidateFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfTokenClaims>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.validate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirms a OTC, and performs an action based on the token type.
         * @summary Validate OTC
         * @param {BfOtcAttempt} bfOtcAttempt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateOtc(bfOtcAttempt: BfOtcAttempt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateOtc(bfOtcAttempt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.validateOtc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Apple OAuth2
         * @param {string} code 
         * @param {string} [state] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuthForm(code: string, state?: string, user?: string, options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.appleAuthForm(code, state, user, options).then((request) => request(axios, basePath));
        },
        /**
         * Callback for Apple OAuth2, from SIWA
         * @summary Apple iOS SIWA Auth
         * @param {BfAppleOAuthResponseCode} bfAppleOAuthResponseCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAppleFromApp(bfAppleOAuthResponseCode: BfAppleOAuthResponseCode, options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.authAppleFromApp(bfAppleOAuthResponseCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Facebook OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebook(options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.facebook(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Google OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        google(options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.google(options).then((request) => request(axios, basePath));
        },
        /**
         * Reports whether a session token or access key is usable now, and the groups its user currently holds (RFC 7662). `active` is false for an expired, revoked, malformed or unknown token. `groupsValidUntil` is how long the reported groups may be cached. The token goes in the form body, never the query string.
         * @summary Introspect token
         * @param {string} token The token as the resource server received it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspect(token: string, options?: RawAxiosRequestConfig): AxiosPromise<BfTokenIntrospection> {
            return localVarFp.introspect(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Microsoft OAuth2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoft(options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.microsoft(options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm the token is valid and return the claims. A 409 carries replacement tokens: after group changes, before expiry, or to upgrade a JWT when `format=compact` is requested.
         * @summary Validate token
         * @param {ValidateFormatEnum} [format] Ask for compact tokens; a session still on a JWT is upgraded with a 409
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(format?: ValidateFormatEnum, options?: RawAxiosRequestConfig): AxiosPromise<BfTokenClaims> {
            return localVarFp.validate(format, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirms a OTC, and performs an action based on the token type.
         * @summary Validate OTC
         * @param {BfOtcAttempt} bfOtcAttempt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOtc(bfOtcAttempt: BfOtcAttempt, options?: RawAxiosRequestConfig): AxiosPromise<BfToken> {
            return localVarFp.validateOtc(bfOtcAttempt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Apple OAuth2
     * @param {string} code 
     * @param {string} [state] 
     * @param {string} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appleAuthForm(code: string, state?: string, user?: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).appleAuthForm(code, state, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Callback for Apple OAuth2, from SIWA
     * @summary Apple iOS SIWA Auth
     * @param {BfAppleOAuthResponseCode} bfAppleOAuthResponseCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authAppleFromApp(bfAppleOAuthResponseCode: BfAppleOAuthResponseCode, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authAppleFromApp(bfAppleOAuthResponseCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Facebook OAuth2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facebook(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).facebook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Google OAuth2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public google(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).google(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reports whether a session token or access key is usable now, and the groups its user currently holds (RFC 7662). `active` is false for an expired, revoked, malformed or unknown token. `groupsValidUntil` is how long the reported groups may be cached. The token goes in the form body, never the query string.
     * @summary Introspect token
     * @param {string} token The token as the resource server received it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public introspect(token: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).introspect(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Microsoft OAuth2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public microsoft(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).microsoft(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm the token is valid and return the claims. A 409 carries replacement tokens: after group changes, before expiry, or to upgrade a JWT when `format=compact` is requested.
     * @summary Validate token
     * @param {ValidateFormatEnum} [format] Ask for compact tokens; a session still on a JWT is upgraded with a 409
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validate(format?: ValidateFormatEnum, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).validate(format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirms a OTC, and performs an action based on the token type.
     * @summary Validate OTC
     * @param {BfOtcAttempt} bfOtcAttempt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateOtc(bfOtcAttempt: BfOtcAttempt, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).validateOtc(bfOtcAttempt, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ValidateFormatEnum = {
    compact: 'compact'
} as const;
export type ValidateFormatEnum = typeof ValidateFormatEnum[keyof typeof ValidateFormatEnum];
